import { WCHANCE_DRAW_STATUS, WCHANCE_LABEL_STATUS, WCHANCE_SURVEY_STATUS } from '@/constants';
import { isAfter, isBefore } from 'date-fns';
import { newDate } from '../../../utils/date';

// Wチャンス抽選ステータスに応じてconstantsのオブジェクトを返す
export const drawStatus = (status: string) => {
  switch (status) {
    case WCHANCE_DRAW_STATUS.won.key:
      return WCHANCE_DRAW_STATUS.won;
    case WCHANCE_DRAW_STATUS.pending.key:
      return WCHANCE_DRAW_STATUS.pending;
    case WCHANCE_DRAW_STATUS.submitted.key:
      return WCHANCE_DRAW_STATUS.submitted;
    case WCHANCE_DRAW_STATUS.lost.key:
      return WCHANCE_DRAW_STATUS.lost;

    default:
      return null;
  }
};

// ラベルのステータスを返す
// 期間終了後であれば完売でも「終了」を返す
export const wchanceLabelStatus = ({
  startAt,
  endAt,
  hasStock,
}: {
  startAt: string;
  endAt: string;
  hasStock: boolean;
}) => {
  // 開始前
  if (isBefore(newDate(), newDate(startAt))) return WCHANCE_LABEL_STATUS.soon_start;
  // 終了
  if (isAfter(newDate(), newDate(endAt))) return WCHANCE_LABEL_STATUS.finish;
  // 完売
  if (!hasStock) return WCHANCE_LABEL_STATUS.sold_out;
  // 抽選期間中
  return WCHANCE_LABEL_STATUS.is_session;
};

// Wチャンスのアンケートステータスを返す
export const getSurveyStatus = (surveyUrl: string, surveyId: string | null, isSurveyCompleted: boolean) => {
  if (!surveyUrl && !surveyId) return WCHANCE_SURVEY_STATUS.no_need_comp;
  if (!isSurveyCompleted) return WCHANCE_SURVEY_STATUS.not_comp;
  return WCHANCE_SURVEY_STATUS.comp;
};
